import React, { useMemo } from 'react'
import { makeStyles, createStyles, Dialog, Box } from '@material-ui/core/'
import { useTranslation } from 'react-i18next'
import Error404Icon from 'src/mobile/assets/icons/errorStatus/404.png'
import Error500Icon from 'src/mobile/assets/icons/errorStatus/500.png'
import NetworkErrorIcon from 'src/mobile/assets/icons/errorStatus/network-error.png'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'
import { setErrorStatus } from 'src/store/slices/authSlice'
import { useDispatch, useSelector } from 'react-redux'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.default,
    },
    img: {
      display: 'block',
      maxWidth: theme.spacing(15),
    },
    button: {
      minWidth: theme.spacing(17),
      height: theme.spacing(4.5),
    },
  }),
)

const ERROR_STATUS_INFO = {
  404: {
    msg: 'tips.can_not_find_page',
    icon: Error404Icon,
  },
  500: {
    msg: 'tips.request_error',
    icon: Error500Icon,
    refresh: true,
  },
  5000: {
    msg: 'tips.please_check_network_and_refresh',
    icon: NetworkErrorIcon,
    refresh: true,
  },
}

const ErrorStatus = ({ isNotFound }) => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const { errorStatus } = useSelector((state) => state.auth)
  const errorCode = isNotFound ? 404 : errorStatus

  const errorInfo = useMemo(() => ERROR_STATUS_INFO[errorCode] || ERROR_STATUS_INFO[500], [errorCode])

  const handleGoHome = (params) => {
    dispatch(setErrorStatus(null))
    history.push(`/${i18n.language}`)
  }

  const handleRefresh = (params) => history.go(0)

  return (
    <Dialog
      PaperProps={{
        classes: {
          root: classes.root,
        },
      }}
      open={Boolean(errorCode)}
      fullScreen
    >
      <Box
        minHeight={120}
        justifyContent="center"
        display="flex"
        flexDirection="column"
        alignItems="center"
        my="auto"
        py={2}
      >
        <img className={classes.img} src={errorInfo?.icon} alt="empty image" />
        <Box mt={2} fontSize="subtitle1.fontSize" textAlign="center" color="grey.400">
          <Box mb={1} fontSize="h4.fontSize" color="grey.800" fontWeight="fontWeightMedium">
            {t(errorInfo?.msg)}
          </Box>
        </Box>
        <Box mt={3}>
          {ERROR_STATUS_INFO[errorCode]?.refresh ? (
            <Button className={classes.button} onClick={handleRefresh} variant="outlined" color="primary">
              {t('common.refresh')}
            </Button>
          ) : (
            <Button className={classes.button} onClick={handleGoHome} variant="outlined" color="primary">
              {t('common.go_back_homepage')}
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  )
}

export default ErrorStatus
